import './App.css';
import V2HomeCard from './V2HomeCard';
import V2HomeCardItem from './V2HomeCardItem';

import { loadAllCampaigns } from './QueryCampaign';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';

function V2HomeCardCampaigns() {
    const navigate = useNavigate();
    const [campaigns, setCampaigns] = useState([]);

    useEffect(
        () => {
            loadAllCampaigns().then(
                (response) => {
                    setCampaigns(response.data);
                }
            ).catch(
                (error) => {
                    console.log(error);
                }
            )
        },
        [],
    )

    if (campaigns.length <= 0) {
        return (
            <div>
                <V2HomeCard
                    icon='pi pi-credit-card'
                    title='Screens'
                >
                    <div className='mk2-title'>
                        0 Campaigns
                    </div>
                    <div>
                        Create your first campaign.
                    </div>
                    <div style={{ marginTop: '0.2em' }}>
                        Less than a minute.
                    </div>
                    <Button
                        severity='success'
                        label='New Campaign'
                        size='small'
                        outlined
                        style={{ marginTop: '1em' }}
                        onClick={() => navigate('/campaigns/new')}
                    />
                </V2HomeCard>
            </div>
        )
    }

    return (
        <V2HomeCard
            title='Campaigns'
            icon='pi pi-th-large'
        >
            <div className='mk2-title'>
                {campaigns.length} campaigns
            </div>
            <V2HomeCardItem
                title='New campaign'
                onClick={() => navigate('/campaigns/new')}
            />
            <V2HomeCardItem
                title='My campaigns'
                onClick={() => navigate('/v2/campaigns')}
            />
            <V2HomeCardItem
                title='External campaigns'
                deactivated={true}
            />
            <V2HomeCardItem
                title='Offers'
                deactivated={true}
            />
        </V2HomeCard>
    );
}

export default V2HomeCardCampaigns;